import { render, staticRenderFns } from "./SmartClassifierDataSetList.vue?vue&type=template&id=49acb27a&scoped=true&"
import script from "./SmartClassifierDataSetList.vue?vue&type=script&lang=js&"
export * from "./SmartClassifierDataSetList.vue?vue&type=script&lang=js&"
import style0 from "./SmartClassifierDataSetList.vue?vue&type=style&index=0&id=49acb27a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49acb27a",
  null
  
)

export default component.exports